export default "__VITE_ASSET__DvXRZ_JU__"